import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backTo?: string;
  backLabel?: string;
  action?: React.ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  backTo,
  backLabel,
  action
}: PageHeaderProps) {
  return <div className="mb-6" data-id="element-207" data-mp="39ghq6s1tlt93">
      {backTo && <Link to={backTo} className="inline-flex items-center gap-1 text-sm font-semibold text-navy-500 hover:text-gold-600 mb-3 transition-colors" data-id="element-208" data-mp="2lq59arolkm6d">
          <ChevronLeft className="w-4 h-4" data-id="element-209" data-mp="2gtol5xhee7ta" />
          {backLabel || 'Back'}
        </Link>}
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3" data-id="element-210" data-mp="2vm89hrzw2aqo">
        <div data-id="element-211" data-mp="2qrkuqkuosupa">
          <h1 className="text-2xl sm:text-3xl font-serif font-bold text-navy-900" data-id="element-212" data-mp="2qruliank35w1">
            {title}
          </h1>
          {subtitle && <p className="text-navy-500 text-sm mt-1" data-id="element-213" data-mp="5zsk1765gljy">{subtitle}</p>}
        </div>
        {action && <div className="shrink-0" data-id="element-214" data-mp="c8vk5wewj2ty">{action}</div>}
      </div>
    </div>;
}